import { ComparableMetric, ListedMetric, MetricRequest } from '@core/models/metric.models'
import { TeamComparisonHolder } from '@pages/team/models/team.models'
import { MetricDetailSubHeader } from '@features/metric-detail/models/metric-detail.models'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'

export const parseTeamComparisonToMetricDetailRequest = (
  context: TeamComparisonHolder,
  value: ListedMetric | ComparableMetric
): MetricRequest => ({
  seasonId: context.teamA.seasonId,
  competitionId: context.teamA.competitionId,
  teamId: context.teamA.id,
  metricKey: value.key,
  compareTeamId: context?.teamB?.id
})

export const parseTeamComparisonMetricDetailSubHeader = (
  metricContext: TeamComparisonHolder
): MetricDetailSubHeader => ({
  imageA: metricContext.logoTeamA,
  textA: metricContext.abbreviationTeamA,
  imageB: metricContext.logoTeamB,
  textB: metricContext.abbreviationTeamB,
  placeholderA: PLACEHOLDER_IMAGES.TEAM,
  placeholderB: PLACEHOLDER_IMAGES.TEAM
})
